import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftRight, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useComparison } from '@/contexts/ComparisonContext';

const ComparisonFloat = () => {
    const { comparisonList, removeFromComparison } = useComparison();

    if (comparisonList.length === 0) return null;

    return (
        <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50 bg-white rounded-full shadow-2xl border border-gray-200 p-2 flex items-center gap-4 animate-in slide-in-from-bottom-10 fade-in duration-300">
            <div className="flex items-center pl-4 gap-2">
                <span className="bg-primary text-white text-xs font-bold px-2 py-1 rounded-full">
                    {comparisonList.length}
                </span>
                <span className="text-sm font-medium text-gray-700 hidden md:inline">
                    Propiedades para comparar
                </span>
            </div>

            <div className="flex -space-x-2">
                {comparisonList.map((prop) => (
                    <div key={prop.id} className="relative w-8 h-8 rounded-full border-2 border-white overflow-hidden group">
                        <img
                            src={prop.multimedia?.fotos?.[0]?.url || prop.image}
                            alt={prop.titulo || prop.title}
                            className="w-full h-full object-cover"
                        />
                        <button
                            onClick={() => removeFromComparison(prop.id)}
                            className="absolute inset-0 bg-black/50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                        >
                            <X size={12} className="text-white" />
                        </button>
                    </div>
                ))}
            </div>

            <Link to="/comparar">
                <Button size="sm" className="rounded-full bg-secondary hover:bg-secondary/90 text-white gap-2">
                    <ArrowLeftRight size={16} />
                    Comparar
                </Button>
            </Link>
        </div>
    );
};

export default ComparisonFloat;
